import styles from './ProductCardPrice.module.scss';
import React from 'react';
import classNames from 'classnames';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  IconText,
  Modal,
  Table,
  Heading,
  Link,
} from '@wienenergiegithub/ui-next';
import { useDialogStore, DialogDisclosure } from '@ariakit/react';

const ProductCardPrice = ({
  area,
  calculated,
  calculationInfo,
  className,
  details,
  legalTextCalc,
  prices,
  isSpotProduct,
  priceSubline,
  priceModal,
  productDetailLink,
}) => {
  const dialog = useDialogStore({ animated: true });

  const renderPriceInfoButton = isSpotProduct => {
    // Only render the icon if there is any content defined
    if (
      !priceModal?.header &&
      !priceModal?.detailText &&
      !priceModal?.showTable &&
      !priceModal?.showLegalText
    )
      return;

    return (
      <DialogDisclosure
        aria-label="Mehr Informationen über den Preis"
        render={
          <Button
            className={classNames(styles.informationButton, {
              [styles.withMargin]: !isSpotProduct,
            })}
            shape="bubble"
          >
            <FontAwesomeProIcon
              className={styles.infoIcon}
              color="primary"
              icon="info-circle"
              role="presentation"
            />
          </Button>
        }
        store={dialog}
      />
    );
  };

  return (
    <>
      {prices.map(({ price, subline }) => (
        <div className={classNames(styles.cardPriceWrapper)} key={price}>
          <Content className={styles.label} size="md">
            {subline}
          </Content>
          {isSpotProduct ? (
            <Heading
              className={classNames(styles.price, styles.isSpotProduct)}
              size="h5"
            >
              <Link
                className={styles.titleLink}
                target="_blank"
                to={productDetailLink}
              >
                Basis: Börsenpreis/Stunde
              </Link>
              {renderPriceInfoButton(isSpotProduct)}
            </Heading>
          ) : (
            <Heading
              as="p"
              className={classNames(styles.price, 'big-entrance-animation')}
              noSpacing
              size="h1"
            >
              {price}
              {!!calculated && renderPriceInfoButton(isSpotProduct)}
            </Heading>
          )}
          <Content className={styles.priceSubline} noSpacing size="md">
            {!!priceSubline.lightContent && priceSubline.lightContent}
            {!!priceSubline.boldContent && (
              <span className={classNames(styles.bold)}>
                {priceSubline.boldContent}
              </span>
            )}
          </Content>
        </div>
      ))}
      {!!calculated && !!calculationInfo && (
        <IconText
          glyph="info-circle"
          hasBackground
          hasBorder
          heading={calculationInfo}
          iconTheme="secondary"
          variant="inline"
        />
      )}
      <Modal header={priceModal?.header} store={dialog}>
        <div className={styles.productModal}>
          {!!priceModal?.detailText && (
            <Content noSpacing={!details}>{priceModal?.detailText}</Content>
          )}
          {priceModal?.showButton && (
            <Button
              render={
                <Link target="_blank" to={productDetailLink}>
                  Verbrauchspreise anzeigen
                </Link>
              }
              theme="primary"
              variant="link"
            />
          )}
          {priceModal?.showTable && (
            <Table className={styles.table}>
              <table>
                <tbody>
                  {details?.map(({ name, shortValue }) => (
                    <tr key={name} tabIndex={0}>
                      <td>{name}</td>
                      <td>{shortValue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Table>
          )}
          {priceModal?.showLegalText && (
            <Content size="regular">
              {/* eslint-disable react/no-danger */}
              <span
                className={styles.legalTextCalc}
                dangerouslySetInnerHTML={{
                  __html: legalTextCalc[area],
                }}
              />
              {/* eslint-enable react/no-danger */}
              <span>{legalTextCalc?.aktion && legalTextCalc?.aktion}</span>
            </Content>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ProductCardPrice;
